<template>
  <div class="left-nav">
    <NavLogo class="logo" :class="{ 'with-back': !!back }" />

    <div v-if="!loading" class="left-nav-items">
      <div class="left-nav-item left-nav-back" v-if="back" @click="back.action">
        <Icon class="nav-icon" icon="angle-left" :size="14" />
        <div class="nav-text">
          {{ back.name ? `${back.name}` : $t("global.go-back") }}
        </div>
      </div>
      <!--      <div class="left-nav-title" v-if="menuTitle">-->
      <!--        {{ truncate(menuTitle, 50) }}-->
      <!--      </div>-->
      <div
        class="left-nav-item"
        v-for="(item, i) in menuItems"
        :key="i"
        @click="item.action"
        :class="{ active: routeMatches(item.routeName) }"
        :data-test="`nav-left-${formatDataTest(item.name)}`"
      >
        <Icon class="nav-icon" :icon="item.icon" :size="14" />
        <div class="nav-text">
          {{ item.name }}
          <Pill v-if="item.admin" class="ml-1" :content="$t('global.admin')" variant="dark" />
        </div>
      </div>
    </div>

    <div v-if="loading" class="left-nav-items">
      <div class="loading-block-container">
        <div class="loading-block nav-loading-block-left"></div>
        <div class="loading-block nav-loading-block-right"></div>
      </div>
      <div class="loading-block-container">
        <div class="loading-block nav-loading-block-left"></div>
        <div class="loading-block nav-loading-block-right"></div>
      </div>
      <div class="loading-block-container">
        <div class="loading-block nav-loading-block-left"></div>
        <div class="loading-block nav-loading-block-right"></div>
      </div>
      <div class="loading-block-container">
        <div class="loading-block nav-loading-block-left"></div>
        <div class="loading-block nav-loading-block-right"></div>
      </div>
    </div>

    <div class="left-nav-footer">
      <div class="left-nav-footer-help">
        {{ $t("global.footer-help") }}
      </div>
      <div class="left-nav-footer-icons">
        <div
          v-for="(helper, h) in helpItems"
          :key="h"
          class="left-nav-icon-container"
          @click="helper.action"
        >
          <Icon :icon="helper.icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/utils/constants";
import Icon from "@/components/display/icon/Icon";
import NavLink from "@/classes/NavLink";
import NavLogo from "@/components/nav/NavLogo";
import Pill from "@/components/display/Pill";
import { truncate } from "leatherman-js/utils/formatters/text";

export default {
  name: "NavLeft",
  components: {
    Icon,
    NavLogo,
    Pill,
  },
  props: {
    homeRoute: {
      type: String,
      default: constants.HOME_ROUTE,
    },
    back: NavLink,
    menuTitle: String,
    menuItems: Array,
    loading: Boolean,
    helpItems: {
      validator: (value) => {
        if (!Array.isArray(value)) {
          return false;
        }

        return value.filter((item) => !item.icon || !item.action).length === 0;
      },
    },
  },
  setup(props, { root }) {
    const formatDataTest = (input) => {
      return input.toLowerCase().replace(/(,|_| |;)/g, "-");
    };

    const routeMatches = (routeName) => {
      const matchedRoutes = [...root.$route.matched];
      const match = matchedRoutes.reverse().find((route) => routeName === route?.name);
      return !!match;
    };

    return { formatDataTest, routeMatches, truncate };
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";

.left-nav-icon-container:hover {
  cursor: pointer;
}

.left-nav {
  width: 215px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .logo {
    margin-bottom: 3rem;

    &.with-back {
      margin-bottom: 1rem;
    }
  }

  .left-nav-items {
    flex-grow: 1;
    overflow-x: hidden;
    overflow-y: auto;
    // scroll-snap-type: y mandatory;

    /* Works on Chrome/Edge/Safari */
    &::-webkit-scrollbar {
      width: 12px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      border-width: 2px;
      border-style: solid;
    }

    /* Works on Firefox */
    scrollbar-width: thin;

    .left-nav-title {
      font-size: 0.875rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 1rem;
      height: $nav-item-height;
      font-weight: 600;
      padding-left: 24px;
      padding-right: 10px;
      word-break: break-word;
    }

    .left-nav-item {
      font-size: 0.875rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      height: $nav-item-height;
      cursor: pointer;
      padding-left: $nav-padding-side;
      scroll-snap-align: end;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }

      .nav-icon {
        margin-right: 1rem;
      }

      .nav-text {
        font-weight: 600;
      }
    }

    .left-nav-back {
      font-size: 0.75rem;

      .nav-text {
        text-transform: uppercase;
      }
    }
  }

  .left-nav-footer {
    height: 100px;
    flex-grow: 0;
    font-size: 0.875rem;
    padding: 20px $nav-padding-side;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;

    .left-nav-footer-icons {
      display: flex;
      align-content: center;
      justify-content: space-around;
    }
  }
}
</style>
